import React, { useEffect } from 'react';
import Detail from '../components/Detail';
import projects from '../projects';

const project = projects[0];

export default () => {
  useEffect(() => window.scrollTo(0, 0));

  return <Detail project={project} />;
};

// componentDidMount() {
//   window.scrollTo(0, 0);
// }

// useEffect(() => {
//   // Update the document title using the browser API
//   window.scrollTo(0, 0);
// })
